import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useEspace } from '../../contexts/EspaceContext';
import { EspaceSidebar } from './EspaceSidebar';

/**
 * Wraps the module pages with the “My Dashboard” sidebar,
 * without changing the pages themselves.
 */
export function EspaceLayout({
  children
}: {
  children: React.ReactNode;
}) {
  const {
    inEspace,
    exitEspace
  } = useEspace();
  const {
    pathname
  } = useLocation();

  // Going back to the site home page leaves the citizen dashboard.
  useEffect(() => {
    if (pathname === '/') exitEspace();
  }, [pathname, exitEspace]);
  if (!inEspace) return <>{children}</>;
  return <div className="flex w-full items-stretch" data-id="element-1012" data-mp="1ax2ghv8l1zu0">
      <EspaceSidebar data-id="element-1013" data-mp="1ev8jqta7pxa6" />
      <div className="min-w-0 flex-1" data-id="element-1014" data-mp="1evi86cflzwdr">{children}</div>
    </div>;
}